export default __webpack_public_path__ + "static/media/About-Tower-viajes-1.5986e9f5.jpg";